import React from 'react';
import { Chip, ChipProps } from '@mui/material';

import { MITStatus } from '../../../../store/modules/mit/types';
import { getMITStatusUi, getMITStatusLabel } from '../../constants';

interface Props extends Omit<ChipProps, 'label' | 'variant'> {
  status: MITStatus;
  size?: 'small' | 'medium';
}

export const MITStatusChip = ({ status, size = 'small', sx, ...props }: Props) => {
  const statusUi = getMITStatusUi(status);

  return (
    <Chip
      icon={statusUi.icon}
      label={getMITStatusLabel(status)}
      size={size}
      sx={{
        backgroundColor: statusUi.color.bg,
        color: statusUi.color.text,

        fontWeight: 600,
        fontSize: size === 'small' ? '12px' : '14px',
        height: size === 'small' ? '24px' : '28px',
        borderRadius: '12px',
        textTransform: 'uppercase',
        '& .MuiChip-icon': {
          color: statusUi.color.text,
          fontSize: '12px',
        },
        ...sx,
      }}
      {...props}
    />
  );
};
